// This file was generated from the unit catalog in `pilot_domain::units`. Do not edit this file manually.

import type { ElectricUsageUnit } from "./ElectricUsageUnit";
import type { GasUnit } from "./GasUnit";
import type { PricingUnit } from "./PricingUnit";

/** The most decimal places a unit preference may ask for. */
export const MAX_UNIT_PRECISION = 5;

/** Electric rate units: `factor` is what one `$/kWh` is in the unit. */
export const ELECTRIC_RATE_UNITS: readonly { code: PricingUnit; label: string; factor: number; defaultPrecision: number }[] = [
  { code: "dollars_per_kwh", label: "$/kWh", factor: 1, defaultPrecision: 4 },
  { code: "cents_per_kwh", label: "¢/kWh", factor: 100, defaultPrecision: 2 },
  { code: "dollars_per_mwh", label: "$/MWh", factor: 1000, defaultPrecision: 2 },
];

/** Electric usage units: `kwhPerUnit` is kWh in one of the unit. */
export const ELECTRIC_USAGE_UNITS: readonly { code: ElectricUsageUnit; label: string; kwhPerUnit: number; defaultPrecision: number }[] = [
  { code: "kwh", label: "kWh", kwhPerUnit: 1, defaultPrecision: 0 },
  { code: "mwh", label: "MWh", kwhPerUnit: 1000, defaultPrecision: 1 },
];

/** Gas units, for rates and usage: `thermsPerUnit` is therms in one of the unit. */
export const GAS_UNIT_CATALOG: readonly { code: GasUnit; rateLabel: string; usageLabel: string; thermsPerUnit: number; defaultRatePrecision: number; defaultUsagePrecision: number }[] = [
  { code: "therms", rateLabel: "$/therm", usageLabel: "therms", thermsPerUnit: 1, defaultRatePrecision: 4, defaultUsagePrecision: 0 },
  { code: "ccf", rateLabel: "$/Ccf", usageLabel: "Ccf", thermsPerUnit: 1, defaultRatePrecision: 4, defaultUsagePrecision: 0 },
  { code: "mcf", rateLabel: "$/Mcf", usageLabel: "Mcf", thermsPerUnit: 10, defaultRatePrecision: 4, defaultUsagePrecision: 1 },
  { code: "dth", rateLabel: "$/Dth", usageLabel: "Dth", thermsPerUnit: 10, defaultRatePrecision: 4, defaultUsagePrecision: 1 },
  { code: "mmbtu", rateLabel: "$/MMBtu", usageLabel: "MMBtu", thermsPerUnit: 10, defaultRatePrecision: 4, defaultUsagePrecision: 1 },
];

/** The units a user who has never chosen reads. */
export const DEFAULT_UNITS = { electricRate: "dollars_per_kwh" as PricingUnit, electricUsage: "kwh" as ElectricUsageUnit, gasRate: "therms" as GasUnit, gasUsage: "therms" as GasUnit };

/** The supplier convention, for anything a supplier reads. */
export const INDUSTRY_UNITS = { electricRate: "dollars_per_mwh" as PricingUnit, electricRatePrecision: 2, electricUsage: "mwh" as ElectricUsageUnit, electricUsagePrecision: 1, gasRate: "dth" as GasUnit, gasRatePrecision: 4, gasUsage: "dth" as GasUnit, gasUsagePrecision: 1 };
